.sectionLinks {
  display: none;
}

.mentorGrid {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 20px;
  padding: 16px;
}

.mentorPanels {
  display: grid;
  grid-template-rows: repeat(auto-fill, 18rem);
  gap: 20px;
}

.mentorCards {
  display: grid;
  grid-template-columns: repeat(auto-fill, 20rem);  
  grid-template-rows: repeat(auto-fill, 18rem);
  gap: 20px;
}

@media screen and (max-width: 768px) {
  .sectionLinks {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: -10px;
    margin-bottom: 40px;
  }

  .sectionLinks a {
    text-decoration: none;
    font-weight: bold;
    color: #f0f0f0;
    font-size: 14px;
    border: 1px solid #084b8a;
    padding: 8px 12px;
    border-radius: 5px;
    background-color: #084b8a;
    transition: all 0.3s ease;
    font-family: "Arial", sans-serif;
  }

  .sectionLinks a:hover {
    background-color: #084b8a;
    color: white;
  }

  .mentorGrid {
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mentorPanels,
  .mentorCards {
    grid-template-columns: 1fr; /* Single column layout for small screens */
  }
}

@media screen and (max-width: 460px) {
  .sectionLinks {
    display: flex;
    justify-content: center;
    gap: 20px;
    height: 30px;
    margin-top: -15px;
    margin-bottom: 30px;
  }

  .sectionLinks a {
    text-decoration: none;
    font-weight: bold;
    color: #f0f0f0;
    font-size: 14px;
    border: 1px solid #084b8a;
    padding: 8px 12px;
    border-radius: 5px;
    background-color: #084b8a;
    transition: all 0.3s ease;
    font-family: "Arial", sans-serif;
  }

  .sectionLinks a:hover {
    background-color: #084b8a;
    color: white;
  }

  .mentorGrid {
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mentorPanels,
  .mentorCards {
    grid-template-columns: 1fr; /* Single column layout for small screens */
  }
}
